// Words in an operation type that are abbreviations, shown in capitals.
const ABBREVIATIONS: Record<string, string> = {
  ou: 'OU',
};

/** 'move-last-user-ou' → 'Move Last User OU'. */
export function formatOperationType(op: string): string {
  return op
    .split('-')
    .map((w) =>
      Object.hasOwn(ABBREVIATIONS, w)
        ? ABBREVIATIONS[w]
        : w.charAt(0).toUpperCase() + w.slice(1)
    )
    .join(' ');
}
